import DialogModal from "@/components/DialogModal";
import CreateLegalEntity from "@/components/CreateLegalEntity";
import { INSTITUTION_PROVIDERS } from "../api";

export default {
  methods: {
    askCreateLegalEntity(data, onSuccess) {
      this.$modal.show(
        DialogModal,
        {
          target: "AskAddLegalEntity",
          title:
            "Pentru a continua este necesar să adăugați persoana juridică în sistem",
          closeBtnText: "",
          button: {
            type: 2,
            value: "Continuă",
            handler: () => {
              this.createLegalEntity(data, onSuccess);
            },
          },
          hideCloseBtn: true,
        },
        {
          name: "AskAddLegalEntity",
          adaptive: true,
          width: "550px",
          height: "auto",
        },
      );
    },

    createLegalEntity(data, onSuccess) {
      this.$modal.show(
        DialogModal,
        {
          target: "AddLegalEntity",
          title: "Adaugă cont persoana juridică",
          inputs: [
            {
              id: "legalEntity",
              type: "component",
              component: CreateLegalEntity,
              componentProps: { cuiInfo: data },
            },
          ],
          acceptFinish: (data) => {
            const entity = data.legalEntity;
            const required = [
              "cui",
              "name",
              "type",
              "county_id",
              "city_id",
              "street_id",
            ];

            for (const key of required) {
              if (!entity[key]) {
                this.$toastr.w(
                  "Nu au fost completate toate câmpurile obligatorii.",
                );
                return false;
              }
            }
            return true;
          },
          closeBtnText: "Renunță",
          button: {
            type: 2,
            value: "Adaugă",
            handler: (data) => {
              const entity = data.legalEntity;

              const error = (msg) => {
                this.$toastr.e(msg || "Adăugarea persoanei juridice a eșuat.");
                this.setLoad(false);
              };

              this.setLoad(true);

              INSTITUTION_PROVIDERS.createLegalEntity({
                cui: entity.cui,
                name: entity.name,
                type: entity.type?.code || entity.type,
                county_id: entity.county_id,
                city_id: entity.city_id,
                street_id: entity.street_id,
                email: entity.email || undefined,
                phone: entity.phone || undefined,
                street_no: entity.number || undefined,
                flat: entity.building || undefined,
                stair: entity.staircase || undefined,
                level: entity.floor || undefined,
                ap: entity.apartment || undefined,
              })
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Persoana juridică a fost adăugată.");
                    onSuccess();
                    this.setLoad(false);
                  } else {
                    error(res?.response || null);
                  }
                })
                .catch(error);
            },
          },
          hideCloseBtn: true,
          customClass: "full-dialog",
        },
        {
          name: "AddLegalEntity",
          adaptive: true,
          width: "880px",
          height: "auto",
        },
      );
    },
  },
};
